import { ConfirmationDialog } from '@/components/ui/ConfirmationDialog'
import { useToast } from '@/components/ui/use-toast'
import { useEstateArchiveDialog } from '@/estate/context/EstateArchiveDialogContext'
import { useGetEstateArchivedQuery, useUpdateEstateMutation } from '@gql'
import React from 'react'
import { useTranslation } from 'react-i18next'
import EstateConfirmDialogContent from './EstateArchiveDialogContent'

export const EstateArchiveDialog = () => {
  const { t } = useTranslation()
  const { toast } = useToast()
  const [update] = useUpdateEstateMutation({
    refetchQueries: ['getEstates'],
  })

  const { estateId, setEstateId } = useEstateArchiveDialog()

  const { data } = useGetEstateArchivedQuery({
    variables: {
      id: estateId!,
    },
    skip: !estateId,
  })

  if (!estateId) return null
  if (!data?.estate_by_pk) return null

  const handleArchive = async () => {
    if (!estateId) return

    if (data?.estate_by_pk?.archived) {
      await update({
        variables: {
          id: estateId,
          values: {
            archived: false,
          },
        },
        onCompleted: () => {
          toast({
            description: t('EstatesTableActionDropdown.toast.activeDesc'),
            variant: 'success',
          })
        },
        onError: (error) => {
          console.error(error)
          toast({
            description: t('EstatesTableActionDropdown.toast.error'),
            variant: 'destructive',
          })
        },
      })
    } else {
      await update({
        variables: {
          id: estateId,
          values: {
            archived: true,
            isSaleOpen: false,
            isPublished: false,
          },
        },
        onCompleted: () => {
          toast({
            description: t('EstatesTableActionDropdown.toast.archivedDesc'),
            variant: 'success',
          })
        },
        onError: (error) => {
          console.error(error)
          toast({
            description: t('EstatesTableActionDropdown.toast.error'),
            variant: 'destructive',
          })
        },
      })
    }
  }

  return (
    <ConfirmationDialog
      open={!!estateId}
      onOpenChange={() => setEstateId(null)}
      onConfirm={handleArchive}
      description={<EstateConfirmDialogContent estate={data.estate_by_pk} />}
    />
  )
}
